import Fetch from "@/utils/Fetch"
import ObjectToFormData from "@/utils/ObjectToFormData"
import filtersToSearchParams from "@/utils/filtersToSearchParams";

export default {
    namespaced: true,
    state() {
        return {
            tendersList: null,
            tendersStatuses: JSON.parse(localStorage.getItem('tenders-statuses')) || null,
            ndsList: JSON.parse(sessionStorage.getItem('nds-list')) || null,
            currenciesList: null,
            favoriteTenders: null,
            favoriteTendersCount: null,
            filter: {
                status: null,
				product: null,
                auctionStartFrom: null,
                auctionStartTo: null,
                auctionEndFrom: null,
                auctionEndTo: null,
                supplyTimeFrom: null,
                supplyTimeTo: null,
                lotSizeFrom: null,
                lotSizeTo: null,
                manager: null,
                unit: null
            },
            pagination: {
                total: 0,
                offset: 0,
                limit: 10,
            },
            offers: [],
        }
    },
    mutations: {
        setState(state, {key, value}) {
            if (!(key in state)) return
            state[key] = value
        },
        setFilterKey(state, {key, value}) {
            if (!Object.hasOwn(state.filter, key)) {
                throw Error('Фильтр не существует')
            } else {
                state.filter[key] = value;
            }
        },
        setPagination(state, paginationData) {
            if (!paginationData) return;
            Object.assign(state.pagination, {...paginationData})
        },
        clearFilter(state) {
            Object.assign(state.filter, {
                status: null,
                auctionStartFrom: null,
                auctionStartTo: null,
                auctionEndFrom: null,
                auctionEndTo: null,
                supplyTimeFrom: null,
                supplyTimeTo: null,
                lotSizeFrom: null,
                lotSizeTo: null,
                manager: null,
                unit: null,
				product: null
            })
        },
        setOffers(state, items) {
            if (state.offers.length) return
            state.offers = []
            items.forEach(item => {
                state.offers.push({
                    position: item.id,
                    price: null,
                    delivery: null,
                    deliveryDestination: null,
                    useRate: false,
                    city: null,
                })
            })
        },
        setOffersKey(state, {id, key, value}) {
            const index = state.offers.findIndex(item => item.position === id);
            if (index === -1) return
            state.offers[index][key] = value

        }
    },
    actions: {
        resetFilter({commit, dispatch}) {
            commit('clearFilter');
            dispatch('requestTendersList', false);
        },
        updateFilterKey({commit}, {key, value}) {
            commit('setFilterKey', {key, value});
            commit('setPagination', {offset: 0, limit: 10});
        },
        updatePagination({commit, dispatch}, paginationData) {
            commit('setPagination', paginationData);
            dispatch('requestTendersList', false);
        },
        updateOffersKey({commit}, {id, key, value}) {
            commit('setOffersKey', {id, key, value});
        },
        async requestTendersStatuses({commit, state, dispatch}) {
            if(state.tendersStatuses) return

            commit('startLoading', 'requestTendersStatuses', {root: true})

            const response = await Fetch('tenders/statuses/', {})

            if (response.success) {
                commit('setState', {key: 'tendersStatuses', value: response.data})
                localStorage.setItem('tenders-statuses', JSON.stringify(response.data))
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestTendersStatuses', {root: true})

            return {
                ...response.data
            }
        },
        async requestTendersList({commit, dispatch, state}) {
            commit('startLoading', 'requestTenderList', {root: true})

            const {offset, limit} = state.pagination;
            const search = filtersToSearchParams(state.filter, offset, limit);

            const response = await Fetch(`tenders/${search}`, {})

            if (response.success) {
                commit('setState', {key: 'tendersList', value: response.data?.items})
                commit('setPagination', {total: Number(response.data?.countTotal)})
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestTenderList', {root: true})

            return {
                ...response.data
            }
        },

        async requestAddTenderToFavorites({commit, dispatch}, id) {
            commit('startLoading', 'requestAddTenderToFavorites', {root: true})

            const body = ObjectToFormData({tender: id});

            const response = await Fetch('tenders/favorites/add/', {method: "POST", body})

            if (response.success) {
                dispatch('requestTendersList')
                dispatch('requestFavoritesTenders')

            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestAddTenderToFavorites', {root: true})

            return {
                ...response.data
            }
        },
        async requestDeleteTenderFromFavorites({commit, dispatch}, id) {
            commit('startLoading', 'requestDeleteTenderFromFavorites', {root: true})

            const body = ObjectToFormData({tender: id});

            const response = await Fetch('tenders/favorites/delete/', {method: "POST", body})

            if (response.success) {
                dispatch('requestTendersList')
                dispatch('requestFavoritesTenders')
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestDeleteTenderFromFavorites', {root: true})

            return {
                ...response.data
            }
        },
        async requestFavoritesTenders({commit, dispatch, state}) {
            commit('startLoading', 'requestFavoritesTenders', {root: true})

            const {offset, limit} = state.pagination;
            const search = filtersToSearchParams(state.filter, offset, limit);

            const response = await Fetch(`tenders/favorites/${search}`, {})

            if (response.success) {
                commit('setState', {key: 'favoriteTenders', value: response.data?.items})
                commit('setState', {key: 'favoriteTendersCount', value: response.data?.countTotal})
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestFavoritesTenders', {root: true})

            return {
                ...response.data
            }
        },
        async requestTenderDetail({commit, dispatch}, id) {
            commit('startLoading', 'requestTenderDetail', {root: true})

            const response = await Fetch(`tenders/get/${id}/`, {})

            if (response.success) {
                commit('setOffers', response.data.positions)
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestTenderDetail', {root: true})

            return {
                ...response
            }
        },
        async requestMakeTenderOffer({commit, dispatch}, data) {
            commit('startLoading', 'requestMakeTenderOffer', {root: true})

            const body = ObjectToFormData(data);

            const response = await Fetch(`tenders/offers/make/`, {method: 'POST', body})

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestMakeTenderOffer', {root: true})

            return {
                ...response
            }
        },
        async requestCancelTender({commit, dispatch}, id) {
            commit('startLoading', 'requestCancelTender', {root: true})

            const response = await Fetch(`tenders/cancel/${id}/`, {method: "POST"})

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestCancelTender', {root: true})

            return {
                ...response
            }
        },

        async requestCopyTender({commit, dispatch}, id) {
            commit('startLoading', 'requestCopyTender', {root: true})

            const response = await Fetch(`tenders/copy/${id}/`, {})

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestCopyTender', {root: true})

            return {
                ...response
            }
        },
        async requesCompleteTender({commit, dispatch}, id) {
            commit('startLoading', 'requesCompleteTender', {root: true})

            const response = await Fetch(`tenders/complete/${id}/`, {method: "POST"})

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requesCompleteTender', {root: true})

            return {
                ...response
            }
        },       
        async rebiddingTender({commit, dispatch}, data) {
            commit('startLoading', 'rebiddingTender', {root: true})
            const body = ObjectToFormData(data);

            const response = await Fetch(`tenders/next-stage/`, {method: 'POST', body})

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'rebiddingTender', {root: true})

            return {
                ...response
            }
        },
        async requestExportTenderToExcel({commit, dispatch}, id) {
            commit('startLoading', 'requestExportTenderToExcel', {root: true})

            const response = await Fetch(`tenders/export/excel/${id}/`)

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestExportTenderToExcel', {root: true})

            return {
                ...response
            }
        },

        async requestTenderItem({commit, dispatch}, id) {
            commit('startLoading', 'requestTenderItem', {root: true})

            const response = await Fetch(`tenders/get/${id}/`)

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestTenderItem', {root: true})

            return {
                ...response
            }
        },

        async requestNdsList({commit, state, dispatch}) {
            if(state.ndsList) return

            commit('startLoading', 'requestNdsList', {root: true})

            const response = await Fetch('info/vat/', {})

            if (response.success) {
                commit('setState', {key: 'ndsList', value: response.data})
                sessionStorage.setItem('nds-list', JSON.stringify(response.data))
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestNdsList', {root: true})

            return {
                ...response.data
            }
        },        
        
        async requestCurrenciesList({commit, dispatch}) {

            commit('startLoading', 'requestcurrencies', {root: true})

            const response = await Fetch('info/currencies/', {})

            if (response.success) {
                commit('setState', {key: 'currenciesList', value: response.data})
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestcurrencies', {root: true})

            return {
                ...response.data
            }
        },
    },



    getters: {
        getTendersList: state => state.tendersList,
        getTendersStatuses: state => state.tendersStatuses,
        getTendersFilter: (state) => (key) => {
            if (key && Object.hasOwn(state.filter, key)) {
                return state.filter[key];
            } else {
                return state.filter;
            }
        },
        getFavoriteTenders: state => state.favoriteTenders,
        getFavoriteTendersCount: state => state.favoriteTendersCount,
        getTendersPagination: (state) => state.pagination,
        getOffersKey: (state) => ({id, key}) => {
            const index = state.offers.findIndex(item => item.position === id);
            if (index === -1) return null
            return state.offers[index][key]
        },
        getOffers: state => state.offers,
        getNdsList: state => state.ndsList,
        getCurrenciesList: state => state.currenciesList
    }
}

